module.exports = __webpack_public_path__ + "media/bootstrap-icons/skip-backward-circle-e437bca1.svg";